var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.sentinalName,staticClass:"w-full h-px relative"})
}
var staticRenderFns = []

export { render, staticRenderFns }